export default {
  'en-US': {
    statusDetails: {
      Picked: 'Picked',
      Packed: 'Packed',
      Labeled: 'Labeled',
      Processing: 'Processing',
      InTransit: 'In-Transit',
      OutForDelivery: 'Out for Delivery',
      Delivered: 'Delivered',
      DeliveryException: 'Delivery Exception',
      Bundle: 'Bundle',
      MergedItem: 'Merged Item',
      InactiveSku: 'Inactive Sku',
      OutOfStock: 'Out of Stock',
      UnknownSku: 'Unknown Sku',
      InternalTransferInProgress: 'Internal Transfer in Progress',
      BinTransferInProgress: 'Bin Transfer in Progress',
      InventoryInNonPickableLocation: 'Non-Pickable Location',
      InventoryPartiallyCommitted: 'Partially Committed',
      PaymentDeclined: 'Payment Failure',
      AddressInvalid: 'Invalid Address',
      WaitForPickDate: 'Wait for Reserve Date',
      WaitForShipDate: 'Wait for Ship Date',
      NoTariffCode: 'Missing Customs Info',
      Manual: 'Manual',
      Shipped: 'Shipped',
      InternationalHazmat: 'International Hazmat',
      PackagePreference: 'Package Preference Not Set',
      AutoProcessingPause: 'Automatic Processing Pause',
      PickInProgress: 'Pick in progress'
    }
  }
}

